// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0d77d33a","607":"e2485624"}[chunkId] + ".chunk.js";
};